import { defineMessages } from 'react-intl';

export const commonMessages = defineMessages({
	download: {
		id: 'download',
		defaultMessage: 'Загрузить',
	},
	chat: {
		id: 'chat',
		defaultMessage: 'Чат',
	},
	operator: {
		id: 'operator',
		defaultMessage: 'Оператор',
	},
	replyYou: {
		id: 'reply.you',
		defaultMessage: 'Вы',
	},
	send: {
		id: 'send',
		defaultMessage: 'Отправить',
	},
	close: {
		id: 'close',
		defaultMessage: 'Закрыть',
	},
	select: {
		id: 'select',
		defaultMessage: 'Выбрать',
	},
});
